// extracted by mini-css-extract-plugin
module.exports = {"modal-wrapper":"Modal_modal-wrapper__34DDO","open":"Modal_open__2iyvn","modal-controls":"Modal_modal-controls__22d22","modal-content":"Modal_modal-content__3t-GS"};